import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import isNumber from "lodash/isNumber";
import isString from "lodash/isString";
import isUndefined from "lodash/isUndefined";
import { useRouter } from "next/router";
import { memo } from "react";
import { ANNOTATION_COMMENT_ID } from "~/components/Annotations/AnnotationsAvatarsContainer/AnnotationAvatarContainer/components/AnnotationComment";
import { hasAnnotation } from "~/components/Annotations/shared/annotationUtils";
import { isViewingDiscussionWithId } from "~/store/router/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const TopCommentContainer = /*#__PURE__*/ memo((param)=>{
    let { discussion, children, onClick } = param;
    const { query } = useRouter();
    const isDiscussionActive = useAirSelector((st)=>isViewingDiscussionWithId(st, discussion.id));
    const timestamp = isString(query.ts) ? parseFloat(query.ts) : undefined;
    const isTimestampActive = isNumber(timestamp) && timestamp === discussion.timestamp;
    const isAnnotation = hasAnnotation(discussion);
    return isAnnotation || !isUndefined(discussion.timestamp) ? /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("cursor-pointer hover:bg-grey-3", isDiscussionActive ? "bg-grey-3" : "bg-transparent", isTimestampActive ? "bg-grey-3" : undefined, isDiscussionActive ? "[&>.comment-menu]:opacity-100" : undefined),
        /**
         * Use to prevent the mousedown event listener from firing when the user clicks on the comment.
         * This event listener is located in:
         * `/src/components/Annotations/shared/useClearAnnotationOnMouseDownOutside.ts`
         */ id: isAnnotation ? ANNOTATION_COMMENT_ID : undefined,
        onClick: onClick,
        role: "button",
        children: children
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
});
TopCommentContainer.displayName = "TopCommentContainer";
